var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81318 0 0 3.81318 0 8.5C0 13.1868 3.81318 17 8.5 17C13.1868 17 17 13.1868 17 8.5C17 3.81318 13.1868 0 8.5 0ZM8.5 15.9375C4.39889 15.9375 1.0625 12.6011 1.0625 8.5C1.0625 4.39889 4.39889 1.0625 8.5 1.0625C12.6011 1.0625 15.9375 4.39889 15.9375 8.5C15.9375 12.6011 12.6011 15.9375 8.5 15.9375Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 3.1875H7.96875V8.71996L11.3119 12.0631L12.0631 11.3119L9.03125 8.28001V3.1875Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGrey);
export default __webpack_public_path__ + "static/media/clock-grey.5e20d14a4598f02d54b7412cdb1bc1cd.svg";
export { ForwardRef as ReactComponent };